import React from 'react'
import { Modal, Space, Typography, Image } from 'antd'
const { Text } = Typography
const ReviewView = ({view,onClose}) => {
    
  return (
    <div>
        <Modal width={500} className='shadow-c'  open={view} onOk={onClose} onCancel={onClose} centered footer={null}>
            <Space className='w-100 py-2 text-center' align='center' size={10} direction='vertical'>
                <Image src='/assets/icons/review-b.png' width={50} preview={false} className='mb-2'/>
                <Space direction='vertical' className='mb-2'>
                    <Text>
                        <strong>Professional review</strong>
                    </Text>
                    {
                        view?.proReview === 1 ? 
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                        </Space>
                        :
                        view?.proReview === 2 ? 
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                        </Space>
                        :
                        view?.proReview === 3 ? 
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                        </Space>
                        :
                        view?.proReview === 4 ? 
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                        </Space>
                        :
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                        </Space>

                    }
                </Space>
                <Space direction='vertical' className='mb-2'>
                    <Text>
                        <strong>Client review</strong>
                    </Text>
                    {
                        view?.clientReview === 1 ? 
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                        </Space>
                        :
                        view?.clientReview === 2 ? 
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                        </Space>
                        :
                        view?.clientReview === 3 ? 
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                        </Space>
                        :
                        view?.clientReview === 4 ? 
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                        </Space>
                        :
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                        </Space>

                    }
                </Space>
                <Text className='text-center fw-500'>
                    “The services are amazing, truly recommended”
                </Text>
            </Space>
        </Modal>
    </div>
  )
}

export {ReviewView}